import { EdsData } from "@coworker/app/src/components/RoomSettings/types/article";
import { ItemTotalQuantity } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemTotalQuantity/ItemTotalQuantity";
import styles from "@coworker/apprestructured/src/media-maintenance/styles/common-media-styles.module.css";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { ItemStockAndEds } from "../ItemStockAndEds/ItemStockAndEds";

interface MediaItemCardWithActionsInnerChildProps {
  item: Item;
  saleStartDate?: string;
  articleHfb?: string;
  shouldDisplayQuantity?: boolean;
  totalQuantityPieces?: number;
  edsData?: EdsData | null;
  itemCardRenderType?: ItemCardRenderType;
  stockInfo?: ItemStockInfo;
}

export const MediaItemCardWithActionsInnerChild = ({
  item,
  saleStartDate,
  articleHfb,
  shouldDisplayQuantity = false,
  totalQuantityPieces,
  edsData,
  itemCardRenderType,
  stockInfo,
}: MediaItemCardWithActionsInnerChildProps) => {
  return (
    <>
      <ItemImage imageUrl={item.smallImageUrl || ""} />
      <div className={styles["item-card-root-column"]}>
        <ItemName name={item.name} />
        {itemCardRenderType &&
        itemCardRenderType === ItemCardRenderType.static ? (
          <ItemNoWithCopy itemNo={item.noFormatted} />
        ) : (
          <ItemNo itemNo={item.noFormatted} />
        )}
        <ItemDescription description={item.description || ""} />
        {saleStartDate && <FixaText>Sale Start Date {saleStartDate}</FixaText>}
        {shouldDisplayQuantity && totalQuantityPieces && (
          <ItemTotalQuantity totalPieces={totalQuantityPieces} />
        )}
        <ItemStockAndEds
          edsData={edsData}
          stockInfo={stockInfo}
          hfb={articleHfb}
        />
      </div>
    </>
  );
};
